import { Modal } from 'antd-mobile'

export default Modal.alert
